export const DB_NAME = "local.db";

export const OfflineDownloadStatus = {
  PENDING: "pending",
  DOWNLOADING: "downloading",
  COMPLETED: "completed",
  FAILED: "failed",
  PAUSED: "paused",
  MARKED_FOR_DELETION: "marked_for_deletion",
  /** File was downloaded but is now missing from disk - needs to be redownloaded */
  NEEDS_REDOWNLOAD: "needs_redownload",
} as const;
